const phoneNumber = () => {
  const usPhone = {
    EMPTY_LENGTH: 0,
    UNFORMATTED_PHONE_COUNTRY_CODE_LENGTH: 2,
    MIN_EXCHANGE_CODE_LENGTH: 4,
    UNFORMATTED_PHONE_AREA_CODE_LENGTH: 6,
    MIN_SUBSCRIBER_NUMBER_LENGTH: 7,
    MAXIMUM_FORMATTED_PHONE_LENGTH: 16,
    VALID_PHONE_LENGTH: 10,
  }

  return {
    usPhone,
  }
}
export default phoneNumber;
